// business_admin_panel/src/hooks/features/products/useFetchProducts.ts
import { stringifyGraph } from '@/clients/http'
import { ProductModel as ProductApiClient } from '@/http/models/Product/Product'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { ProductModel } from '@/types/model/Product'

// Assuming ProductHttpParams exists in a similar structure to ProductCategoryHttpParams
// I will define it based on what I infer the API expects for getList.
export namespace ProductHttpParams {
  export interface GetList {
    params?: {}
    query?: {
      search?: string
      status?: 'active' | 'inactive' | 'all' | undefined
      page?: number
      limit?: number
      sort?: string
      graph_enc?: string
    }
    store?: any
  }
}

export interface ProductListFilters {
  search?: string
  status?: 'active' | 'inactive' | 'all' | undefined
}

export interface ProductListForm extends UseFetchListForm<
  ProductListFilters,
  ProductModel.Product
> {}

interface UseFetchProductsProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const productInitialFilters: ProductListFilters = {
  search: '',
  status: undefined,
}

export const useFetchProducts = ({ sort, shouldFetchList }: UseFetchProductsProps) => {
  return useFetchList<
    ProductListFilters,
    ProductModel.Product,
    {},
    ProductHttpParams.GetList['query'],
    typeof ProductApiClient.getList
  >({
    pageSize: 10,
    initialFilters: productInitialFilters,
    fetchFunction: ProductApiClient.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<ProductHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      status: filters.status || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        thumbnail: {
          path: true,
          versions: true,
        },
        category: {
          name: true,
        },
        brand: {
          name: true,
        },
        'variations.count': true,
      }),
    }),
    buildParams: () => ({}),
  })
}
